import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesHrDocumentationToken } from '@libs/generated-types/utilities';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
    providedIn: 'root',
})
export class HrDocumentationService {
    private readonly apiUrl: string = '';

    constructor(
        private readonly http: HttpClient,
        private readonly environmentService: EnvironmentService,
    ) {
        // Use environment service to get the API URL
        this.apiUrl = this.environmentService.utilitiesServiceUrl + '/hr-documentation';
    }

    getHrDocumentationToken(): Observable<UtilitiesHrDocumentationToken> {
        const url = `${this.apiUrl}`;
        return this.http.get<UtilitiesHrDocumentationToken>(url);
    }
}
